export function SettingsAdminIntro() {
  return (
    <div className="border border-border bg-card px-4 py-4">
      <p className="text-[11px] font-semibold uppercase text-brand-gold-dark">Administration</p>
      <h2 className="mt-1 text-lg font-semibold text-foreground">Règles de fonctionnement</h2>
      <p className="mt-1 max-w-3xl text-sm text-muted-foreground">
        Ajustez les paramètres par domaine, la visibilité des modules et le catalogue des
        commissions. Les actions sensibles sont signalées avant modification.
      </p>
    </div>
  );
}
